// extracted by mini-css-extract-plugin
module.exports = {"container":"ExpiredLink_container__3NG0_","title":"ExpiredLink_title__RjNy6","subtitle":"ExpiredLink_subtitle__6RaLG","image":"ExpiredLink_image__2mzrG"};